import React, { useState } from "react";
import { Container, Nav, Col, Row } from "react-bootstrap";
import { Link } from "gatsby";

import StoryblokImage from "../../internal/storyblokImage/StoryblokImage";
import StoryblokLink from "../../internal/storyblokLink/StoryblokLink";
import useSiteSettings from "../../../hooks/useSiteSettings";
import * as styles from "../navbar/Navbar.module.scss";
import SiteSocialLinks from "../siteSocialLinks/SiteSocialLinks";
import IconHamburger from "../../../../static/images/icon_hamburger.svg";
import IconTimes from "../../../../static/images/icon_times.svg";
import Buttons from "../../internal/buttons/Buttons";




function Trimmer(text) {
  let str = `${text}`.trim();
  return str.replace(/^\//, "").replace(/\/$/, "");
}

const RenderNavPages = ({ navigation, location }) => {
  return (
    <div className="justify-content-end">
      {navigation.map((navItem, idx) => {
        let path = !navItem.customPath ? navItem.path : navItem.customPath;
        let active = Trimmer(location.pathname) === Trimmer(path);
        return (
          <div
            className={`${styles.navItem}${
              active ? ` ${styles.navItemActive}` : ""
            }`}
            key={`${idx}_${path}`}
          >
            <a href={path}>
              {!navItem.menuCaption ? navItem.name : navItem.menuCaption}
            </a>
          </div>
        );
      })}
    </div>
  );
};

const LandingNav = ({ navigation, lang, location, content}) => {
  const settings = useSiteSettings(lang);

  const { header_link, header_link_text, logo_link, display_header_link, display_socials } = content

  const { buttons, site_logo, language_selector, top_nav_buttons } =
    settings || {};

  const [showNav, setShowNav] = useState(false);

  function handleToggleNav() {
    setShowNav(!showNav);
  }

  return (
    <div className={`navbar-wrapper-class ${styles.wrapper}`}>
      <div className="desktopOnly">
        <Container>
          <Row className={"align-items-center justify-content-between"}>
            <Col md="2" style={{paddingLeft: 0}} className="logo">
            {
              logo_link?.url || logo_link?.id || logo_link?.cached_url ? 
              <StoryblokLink text={logo_link} withClass={``} SBLinkData={logo_link} newWindow={logo_link?.target === "_blank"}>
                <StoryblokImage sbImageData={site_logo} width={172} height={41} />
              </StoryblokLink> 
              :
              <StoryblokImage sbImageData={site_logo} width={172} height={41} />
            }
            </Col>
            {display_header_link || display_socials ? <Col md="auto" style={{ padding: 0 }}>
              <Container style={{ padding: 0 }}>
                <Row className="align-items-center">
                  {display_header_link ? <Col>
                    <div
                      className={`${styles.navItem} navbar-landing`}
                    >
                      <StoryblokLink text={header_link_text} withClass={``} SBLinkData={header_link} newWindow={header_link?.target === "_blank"}/>
                    </div>
                  </Col> : null }
                  {display_socials ? <Col md={"auto"} className={"justify-content-end"}>
                    <div className="footer-lang">
                      <SiteSocialLinks settings={settings}/>
                    </div>
                  </Col> : null }
                </Row>
              </Container>
            </Col> : null }
          </Row>
        </Container>
        <div id="mainNav" className="nav-wrapper">
          <Container/>
        </div>
      </div>
      <div className={`mobileOnly ${styles.mobileNav}`}>
        <Container>
          <div className={styles.mobileNavLogo}>
          {
              logo_link?.url || logo_link?.id || logo_link?.cached_url ? 
              <StoryblokLink text={logo_link} withClass={``} SBLinkData={logo_link} newWindow={logo_link?.target === "_blank"}>
                <StoryblokImage sbImageData={site_logo} width={172} height={41} />
              </StoryblokLink> 
              :
              <StoryblokImage sbImageData={site_logo} width={172} height={41} />
            }
          </div>
          {display_header_link ? <div className={styles.mobileNavRight}>
            <div
              style={{
                display: "inline-block",
                paddingTop: 4,
                alignItems: "top",
                marginRight: 20,
              }}
            >
            </div>
            <div onClick={handleToggleNav} style={{ display: "inline-block" }}>
              {showNav ? (
                <img src={IconTimes} alt="menu" />
              ) : (
                <img src={IconHamburger} alt="menu" />
              )}
            </div>
          </div> : null}
          <div style={{ clear: "both" }} />
        </Container>
        {showNav ? (
          <>
            <div className={styles.backdrop} onClick={handleToggleNav} />
            <div className={styles.content}>
              <div className={`mobile-pages ${styles.navItem}`}>
                <StoryblokLink text={header_link_text} SBLinkData={header_link} newWindow={header_link?.target === "_blank"}/>
              </div>   
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default LandingNav;
